var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"view view--embed embed"},[_c('div',{staticClass:"embed__body"},[_c('router-view',{staticClass:"embed__header",attrs:{"name":"header"}}),_c('router-view',{staticClass:"embed__content",attrs:{"name":"content"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }